type Size = "sm" | "md" | "lg";

const SIZE_MAP: Record<Size, { width: number; height: number }> = {
  sm: { width: 60, height: 4 },
  md: { width: 80, height: 6 },
  lg: { width: 120, height: 8 },
};

const STATUS_COLORS: Record<string, string> = {
  not_started: "hsl(215,16%,60%)",
  in_progress: "hsl(210,100%,50%)",
  completed: "hsl(142,72%,40%)",
  at_risk: "hsl(32,90%,50%)",
  delayed: "hsl(0,70%,50%)",
  cancelled: "hsl(215,16%,60%)",
};

type Props = {
  progress: number;
  status: string;
  size?: Size;
};

export function MilestoneProgressBar({ progress, status, size = "md" }: Props) {
  const s = SIZE_MAP[size];
  const color = STATUS_COLORS[status] ?? "hsl(215,16%,60%)";
  const displayProgress =
    status === "completed" ? 100 : Math.max(0, Math.min(100, progress));
  const cancelled = status === "cancelled";

  return (
    <div
      style={{
        width: s.width,
        height: s.height,
        background: "hsl(210,16%,93%)",
        borderRadius: 999,
        overflow: "hidden",
        opacity: cancelled ? 0.6 : 1,
      }}
    >
      <div
        style={{
          width: `${displayProgress}%`,
          height: "100%",
          background: color,
          borderRadius: 999,
          transition: "width 200ms ease",
        }}
      />
    </div>
  );
}
